import { FC } from "react";

import { IconProps, initializeSvgIconProps } from "mds/utils/images";

export const ViewPersonIcon: FC<IconProps> = (props) => (
  <svg {...initializeSvgIconProps(props)}>
    <path
      d="M11.9 10.7412C11.9001 10.6447 11.8769 10.5495 11.8324 10.4639C11.7879 10.3782 11.7234 10.3046 11.6444 10.2492C10.5619 9.5482 9.2884 9.20099 7.99998 9.25558C6.71155 9.20099 5.43801 9.5482 4.35558 10.2492C4.27654 10.3046 4.21204 10.3782 4.16754 10.4639C4.12304 10.5495 4.09987 10.6447 4.09998 10.7412V12.2556H11.9V10.7412Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="0.8"
    />
    <path
      d="M8.00002 7.45C9.15982 7.45 10.1 6.5098 10.1 5.35C10.1 4.1902 9.15982 3.25 8.00002 3.25C6.84023 3.25 5.90002 4.1902 5.90002 5.35C5.90002 6.5098 6.84023 7.45 8.00002 7.45Z"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="0.8"
    />
    <path d="M1 4V1H4" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M12 1L15 1L15 4" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M15 12L15 15L12 15"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M4 15L1 15L1 12" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
